import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import DateFormat from "../components/DateFormat";
import { DriverLink } from "../components/FlagLink";
import { getAbbreviation } from "../utils/Standings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const DriversLicenses = () => {
  const { t } = useTranslation();
  document.title = "LVF1 - " + t("DriversLicenses");
  const [rows, setRows] = useState<DriverLicenseRow[]>([]);
  //const [licenses, setLicenses] = useState<DriverLicense[]>();

  const getJSXPoints = (penalty: PointResult) => {
    if (
      penalty.value_penalty !== penalty.value_transformed &&
      penalty.value_transformed > 0
    ) {
      return (
        <b>
          <span className="strike">{penalty.value_penalty}</span>{" "}
          {penalty.value_transformed} pts{" "}
        </b>
      );
    } else {
      return <b>{penalty.value_penalty} pts </b>;
    }
  };

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/driver/getLicenses`,
      )
      .then(({ data }: { data: DriverLicense[] }) => {
        let rows_: DriverLicenseRow[] = [];

        data.forEach((driver: DriverLicense, index) => {
          rows_.push({
            position: <div className="license-position">{index + 1}</div>,

            driver: (
              <div className="license-driver">
                <DriverLink
                  flag_code={driver.flag_code}
                  flag_name={driver.flag_name}
                  name={driver.username}
                  nickname={driver.username}
                  abbreviation={getAbbreviation(driver.username)}
                />
              </div>
            ),

            points: (
              <div className="license-points">
                <span>{driver.points}</span>
                <small>pts</small>
              </div>
            ),

            points_history: (
              <div className="license-penalty-container">
                {driver.points_results.map((point_result, penaltyIndex) => {
                  const inactive = point_result.value_transformed === 0;

                  return (
                    <span
                      key={`${point_result.name}-${point_result.date}-${penaltyIndex}`}
                      className={`license-penalty ${
                        inactive ? "license-penalty-inactive" : ""
                      }`}
                      title={point_result.name}
                    >
                      <Link
                        to={`${t("routes:Findings")}/${point_result.name.replace(
                          / /g,
                          "",
                        )}`}
                        className="license-penalty-link"
                      >
                        <span className="license-penalty-points">
                          {getJSXPoints(point_result)}
                        </span>

                        <span className="license-penalty-date">
                          <DateFormat
                            date={point_result.date}
                            format="normal"
                          />
                        </span>
                      </Link>
                    </span>
                  );
                })}
              </div>
            ),
          });
        });

        setRows(rows_);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, []);

  const columns = [
    {
      name: t("Drivers"),
      selector: (row: DriverLicenseRow) => row.driver,
      width: "250px",
    },
    {
      name: t("RemainingPoints"),
      selector: (row: DriverLicenseRow) => row.points,
      sortable: true,
      width: "220px",
    },
    {
      name: t("Penalties"),
      selector: (row: DriverLicenseRow) => row.points_history,
    },
  ];

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div id="drivers-licenses" className="no-second-padding ">
        <div className="flex">
          <label className="text-left label-title-gp">
            {t("DriversLicenses").toUpperCase()}
          </label>
          <div className="dl-legend flex ">
            <div className="flex">
              <div className="legend-color lpoints"></div>
              <label>{t("CurrentPointsRemaining")}</label>
            </div>
            <div className="flex">
              <div className="legend-color lpenalty"></div>
              <label>{t("ActivePenalties")}</label>
            </div>
            <div className="flex">
              <div className="legend-color license-penalty-inactive"></div>
              <label>{t("PenaltiesLossLicense")}</label>
            </div>
            <div className="flex ">
              <FontAwesomeIcon icon={faInfoCircle} />
              <label>{t("PointsRestorement")}</label>
            </div>
          </div>
        </div>
        <DataTable columns={columns} data={rows} />
      </div>
    </div>
  );
};

export default DriversLicenses;
